import { AsyncState, Maybe } from 'ballerina-core'

export type SiteBannerState = AsyncState<Maybe<SiteBanner>>

export type SiteBanner = { content: string; closed: boolean }

export const initialSiteBannerState: SiteBannerState = AsyncState.Default.unloaded()
